import React from 'react'
import { Button } from 'reactstrap'
import { Field, reduxForm } from 'redux-form'
import { connect } from 'react-redux'
import PropTypes from 'prop-types'
import FormattedMessage from '../../FormattedMessage/FormattedMessage'
import { renderField } from '../../../utilities/reduxForm.util'
import { dateRequired, required } from '../../../utilities/validators'
import languageOptions from '../../../../shared/languageCodes.json'
import countryCodes from '../../../../shared/countryCodes.json'
import Loader from '../../Loader/Loader'
import { currentUser } from '../../../redux/reducers/user.reducers'

const availableLanguages = () =>
  languageOptions
    .filter(lang => lang.active)
    .map(lang => ({ value: lang.code, key: lang.nativeName }))

class MyAccountForm extends React.Component {
  renderLanguageField() {
    const { countryLoading, languageCode, handleChange } = this.props
    const availableLanguageOptions = availableLanguages()

    if (countryLoading) {
      return (
        <div>
          <label className="form-label-sm">
            <FormattedMessage id="global.label.language" />
          </label>
          <div aria-live="polite" aria-label="Loading language options">
            Loading...
          </div>
        </div>
      )
    }

    return (
      <Field
        component={renderField}
        className="form-control"
        inputType="select"
        name="language"
        label="global.label.language"
        placeholder={countryLoading ? 'Loading...' : 'global.label.language'}
        value={languageCode}
        options={availableLanguageOptions}
        onChange={handleChange}
      />
    )
  }

  render() {
    const { error, submitting, initialValues, handleSubmit, valid } = this.props

    return (
      <form onSubmit={handleSubmit} method="post" aria-labelledby="account-form-title">
        <div id="account-form-title" className="sr-only">
          My account form
        </div>
        <div disabled={submitting}>
          <div className="sr-only">Personal information</div>
          <div className="row">
            <Field
              component={renderField}
              validate={[required]}
              inputType="input"
              type="text"
              containerclass="col-md-12 col-lg-6 form-group"
              name="firstname"
              label="global.label.firstName"
            />
            <Field
              component={renderField}
              validate={[required]}
              inputType="input"
              type="text"
              containerclass="col-md-12 col-lg-6 form-group"
              name="lastname"
              label="global.label.lastName"
            />
          </div>
          <div className="row">
            <Field
              component={renderField}
              validate={[dateRequired]}
              inputType="date"
              type="date"
              containerclass="col form-group"
              disabled
              name="dob"
              label="global.label.birthdate"
              aria-describedby="dob-readonly-note"
            />
            <div id="dob-readonly-note" className="sr-only">
              This field cannot be modified
            </div>
          </div>
          <div className="row">
            <div className="col-md-12 col-lg-6 form-group">
              <label className="form-label-sm">
                <FormattedMessage id="global.label.country" />
              </label>
              <div
                className="form-control"
                role="textbox"
                aria-readonly="true"
                aria-describedby="country-readonly-note"
              >
                {countryCodes.map(
                  country => country.code === initialValues.country && country.name
                )}
              </div>
              <div id="country-readonly-note" className="sr-only">
                This field cannot be modified
              </div>
            </div>
            <div className="col-md-12 col-lg-6 form-group">{this.renderLanguageField()}</div>
          </div>
          {error && (
            <div className="form-validation-error-message mb-2" role="alert" aria-live="polite">
              <FormattedMessage id={error} />
            </div>
          )}
          {submitting ? (
            <Loader aria-label="Saving account changes" />
          ) : (
            <Button
              name="myAccountFormSubmitBtn"
              type="submit"
              outline
              color="dark"
              block
              disabled={!valid}
              aria-disabled={!valid}
              aria-describedby={error ? 'account-form-error' : undefined}
            >
              <FormattedMessage id="global.label.saveChanges" />
            </Button>
          )}
        </div>
      </form>
    )
  }
}

const validate = () => {
  const errors = {}
  return errors
}

MyAccountForm.propTypes = {
  initialValues: PropTypes.object.isRequired,
}

const mapStateToProps = state => ({
  initialValues: currentUser(state),
})

export default connect(mapStateToProps)(
  reduxForm({
    form: 'myAccount',
    validate,
  })(MyAccountForm)
)
